import axios from "axios"





export  const getEmpresaRepresentante = async (sid,empid,usuario) => {

    try {

      const response = await axios.post(`${process.env.REACT_APP_API_URL_BACK}api/helpers/usuario`,{
        sid,empid,usuario
      })

      return response.data
      
    } catch (error) {
       console.log(error)
    }



  }


 export const consultarFirmaContratada = async (portal,emp) => {


     try {
       
         const response = await axios.post(`${process.env.REACT_APP_API_URL_BACK}api/helpers/firmaContratada`, {
           sid:portal,empid:emp
         })


         return response.data

         
     } catch (error) {


        console.log(error)
       //  dispatch(setFirmaContratada('N'))
     }


}